import { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { useBreadcrumbsContext } from '../../../../app/context';
import { MainPageContent } from './components/MainPageContent';
import { MainPageContainer } from './styles';
import { BoxIcon } from 'app/components/Icons';

const ProductsMain = () => {
  const theme = useTheme();
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();

  useEffect(() => {
    setItems(
      [{ to: '/products/main', label: 'Produtos' }],
      <BoxIcon color={theme.palette.text.secondary} />,
    );

    return () => resetBreadcrumbs();
  }, []);

  return (
    <MainPageContainer>
      <MainPageContent />
    </MainPageContainer>
  );
};

export default ProductsMain;
